(function() {
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('clickable')) {
            e.target.querySelector("a").click();
        }
        
        if (e.target.closest('.js-scrollToTop')) {
            e.preventDefault();
            const mobileHubSidebar = document.querySelector('.c-mobile-hub__sidebar');
            if (mobileHubSidebar?.classList.contains('is-open')) {
                toggleMobileHub();
            }
    
            let currentScroll = document.documentElement.scrollTop;
            let duration = (Math.ceil(currentScroll / 1000) * 20) + 250;
    
            scrollToTop(0, duration);
        }

        const siteHeaderButton = e.target.closest('.c-site-header__button');
        if (siteHeaderButton) {
            siteHeaderButton.parentNode.querySelector('form')?.submit();
        }
    });
    
    
    function scrollToTop(scrollTo, duration) {
        let start = document.documentElement.scrollTop;
        let change = scrollTo - start;
        let currentTime = 0;
        let increment = 20;
    
        function animateScroll() {
            currentTime += increment;
            let val = easeInOutQuad(currentTime, start, change, duration);
            document.documentElement.scrollTop = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        }
    
        animateScroll();
    }
    
    function easeInOutQuad(t,b,c,d){return(t/=d/2)<1?c/2*t*t+b:-c/2*((--t)*(t-2)-1)+b;}

    var backToTopButton = document.querySelector('.c-back-to-top');
    var siteFooter = document.querySelector('.c-site-footer');
    
    if (backToTopButton) {
        window.addEventListener('scroll', function(event) {
            var st = window.pageYOffset || document.documentElement.scrollTop,
                wh = window.innerHeight,
                fo = siteFooter.getBoundingClientRect();
    
            if (st > 200 && (st + wh) < fo.top) {
                backToTopButton.classList.add('is-visible');
            } else {
                backToTopButton.classList.remove('is-visible');
            }
        });
    }

    Global = {
        /*
        * Desc: Check for errors within a form
        * Required: form element
        * Return: boolean
        */
        ajaxSubmitErrors: function(form) {
            var errors = form.querySelectorAll('div.has-error');
            if (errors.length > 0) {
                return true; // Errors found
            } else {
                return false; // No errors found
            }
        }
    };
})();
